import UtilityService from '@/services/UtilityService';

export default class NotificationService {
	constructor(i) {
		this.appToaster = i.$toast;
	}

	showPopup(title, message, type) {
		this.appToaster.show(`<h3 class="title">${title}</h3><p class="message">${message}</p>`, {
			type,
			duration: 4000,
		});
	}

	success(text) {
		this.showPopup('Completed', text, 'success');
	}

	error(e) {
		const text = UtilityService.extractErrorMessage(e);
		this.showPopup('Oops', text, 'error');
	}

	warning(text) {
		this.showPopup('Attention', text, 'warning');
	}

	info(text) {
		this.showPopup('Info', text, 'info');
	}
}
